// The installable technician page (PRD 95 §4.13): on field pages the document
// names "Greenback Field" — its own manifest, starting at My day — instead of
// the personal-finance app's, and puts the original back on leaving. Whether a
// browser reads a manifest swapped after load is UNVERIFIED; *Add to Home
// Screen from My day* works either way on iOS, which starts where it was added.

import { useEffect } from 'react';

export const FIELD_MANIFEST = 'field-manifest.json';
export const FIELD_APP_TITLE = 'Greenback Field';

export function useFieldManifest(): void {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    const title = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    const previousHref = link?.getAttribute('href') ?? null;
    const previousTitle = title?.getAttribute('content') ?? null;
    link?.setAttribute('href', `${process.env.PUBLIC_URL ?? ''}/${FIELD_MANIFEST}`);
    title?.setAttribute('content', FIELD_APP_TITLE);
    return () => {
      if (link && previousHref !== null) link.setAttribute('href', previousHref);
      if (title && previousTitle !== null) title.setAttribute('content', previousTitle);
    };
  }, []);
}
